<!--
 * @Author: guoyu
 * @Date: 2021-04-16 17:00:33
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-04 15:08:05
 * @Description: file content
-->
<template>
  <div class="gift-wall">
    <div class="gift-block-title">
      <span>{{$t('upgrade_page_views_master_components_my_gift_236')}}</span>
      <span class="all-gift" @click="showMore = !showMore"
        >{{$t('upgrade_page_views_master_components_rank_list_226')}}<i class="el-icon-arrow-right"></i
      ></span>
    </div>
    <div v-if="loadingGiftWall" class="loading-container">
      <i class="el-icon-loading"></i>
    </div>
    <div v-else-if="!giftList.length" class="no-revice-gift">
      <img src="~@/assets/image/background/empty-gift.png" />
      <span>{{$t('upgrade_page_views_master_components_rank_list_227')}}</span>
    </div>
    <div class="gift-container">
      <div
        v-for="(g, i) in displayList"
        :key="g ? 'gift-' + g.id : i"
        class="one-gift"
      >
        <!-- <div v-if="g">
          <el-popover
            placement="top"
            popper-class="popper-clear-style popover-gift"
            trigger="hover"
            :width="128"
            :visible-arrow="false"
          >
            <div class="gift-detail">
              <img class="gift-image" :src="g.imageUrl" />
              <span class="gift-name">{{ g.name }}</span>
              <div class="gift-amount">
                <img class="icon" src="~@/assets/image/icons/gold-icon.png" />
                <span class="price">{{ g.paymentAmount }}</span>
              </div>
            </div> -->
        <img slot="reference" class="gift-image" :src="g.imageUrl" />
        <!-- </el-popover> -->
        <span class="gift-count">x{{ g.count }}</span>
      </div>
    </div>
    <div class="footer-container">
      <el-popover
        v-model="showSendGift"
        placement="top-start"
        :title="$t('upgrade_page_views_master_components_rank_list_233')"
        width="399"
        trigger="click"
        class="send-gifts one-btn"
        popper-class="send-gifts-popover"
      >
        <fps-icon
          class="close-popover"
          type="close"
          @click.native="showSendGift = false"
        />
        <SendGift
          ref="send_gift"
          startPadding="2.5px 7.5px"
          :playerUserUuid="playerInfo.uuid"
          :success="sendGiftSuccess"
        />
        <div class="send-gift-button" slot="reference">
          <img class="gift-icon" src="../images/gift-icon.png" />{{$t('upgrade_page_views_master_components_my_gift_237')}}</div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import SendGift from '@/components/SendGifts';
export default {
  components: {
    SendGift
  },
  props: {
    masterUuid: {
      type: [String, Number],
      default: ''
    },
    playerInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isSelf: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loadingGiftWall: false,
      giftList: [],
      showMore: false,
      showSendGift: false
    };
  },
  computed: {
    displayList() {
      if (!this.showMore) return this.giftList.slice(0, 4);
      return this.giftList;
    }
  },
  methods: {
    sendGiftSuccess(gift) {
      this.showSendGift = false;
      this.$emit('sendgiftsuccess', gift);
    },
    updateGiftWall() {
      this.loadingGiftWall = true;
      this.giftList = [];
      this.$http
        .post('/gift/wall', {
          playerUserUuid: this.masterUuid
        })
        .then(({ data: { giftList } }) => {
          this.loadingGiftWall = false;
          this.giftList = giftList;
        });
    }
  },
  created() {
    this.updateGiftWall();
  }
};
</script>
<style lang="scss" scoped>
.gift-container {
  display: flex;
  max-width: 100%;
  flex-wrap: wrap;
  padding: 0 16px;
}
.gift-block-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  padding: 0 16px;
  font-weight: 500;
  font-size: 17px;
}
.all-gift {
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #8c94aa;
  cursor: pointer;
}
.el-icon-arrow-right {
  font-weight: 700;
}
.gift-wall {
  width: 100%;
  padding: 0 0 16px;
  margin-top: 16px;
  background: #ffffff;
  .gift-wrap {
    @include flex(space-between);
    &:not(:first-child) {
      margin-top: 48px;
    }
  }
  .one-gift {
    width: 25%;
    @include flex(center, center, column);
    .gift-image {
      height: 64px;
    }
    .gift-count {
      margin-top: 11px;
      padding: 1px 8px;
      border-radius: 10px;
      background: #f99f35;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: #fff;
    }
  }
  .no-revice-gift {
    font-size: 14px;
    line-height: 21px;
    color: $color-gray-3;
    @include flex(flex-start, center, column);
    img {
      height: 70px;
      margin-top: 82px;
      margin-bottom: 18px;
    }
  }
}
.footer-container {
  display: flex;
  justify-content: flex-end;
  padding: 14px 0 2px;
  border-top: 1px solid #f1f4f6;
  margin-top: 24px;
}
.send-gift-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 14px;
  width: auto;
  padding: 0 16px;
  font-size: 12px;
  line-height: 14px;
  background: none;
  color: #636d86;
  border-radius: 30px;
  cursor: pointer;
}
.gift-icon {
  height: 18px;
  width: 18px;
  margin-right: 8px;
}
</style>
